import React from "react";
import { Questionnaire } from "../Questionnaire";
import { log } from "../../utils/logger";

export const Anketa = () => {
    const questions = [
        { id: 1, text: "Вы являетесь ИП?", correctAnswer: "ДА" },
        { id: 2, text: "Есть ли у вас сотрудники?", correctAnswer: "НЕТ" },
        { id: 3, text: "Система налогообложения УСНО (объект доходы) или нет?", correctAnswer: "ДА" },
        { id: 4, text: "Есть ли необходимость оформления отгрузочных документов (актов, накладных, УПД, счетов-фактур) покупателям?", correctAnswer: "НЕТ" }
    ];

    return (
        <Questionnaire
            questions={questions}
            title="Регистрация"
            redirectPath="/register"
            showCorrectAnswers={true}
            successMessage=""
            errorMessage="К сожалению, наши услуги не подходят на основе ваших ответов."
            onComplete={(answers, hasWrongAnswer) => {
                log("Anketa", "Анкета завершена", { answers, hasWrongAnswer });
            }}
        />
    );
};